'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
var classNames = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getBorderColor = function getBorderColor(theme) {
  return function (_ref) {
    var color = _ref.color;

    switch (color) {
      case 'primary':
        return theme.palette.primary.light;

      case 'success':
        return theme.palette.success.dark;

      case 'error':
        return theme.palette.error.main;

      default:
        return theme.palette.secondary['400'];
    }
  };
};

var getColor = function getColor(theme) {
  return function (_ref2) {
    var color = _ref2.color;

    switch (color) {
      case 'primary':
        return theme.palette.primary.dark;

      case 'success':
        return theme.palette.success.dark;

      case 'error':
        return theme.palette.error.main;

      default:
        return theme.palette.secondary.main;
    }
  };
};

var getBackgroundColor = function getBackgroundColor(theme) {
  return function (_ref3) {
    var color = _ref3.color;

    switch (color) {
      case 'primary':
        return theme.palette.primary['50'];

      case 'success':
        return theme.palette.success.light;

      case 'error':
        return theme.palette.error.light;

      default:
        return theme.palette.secondary['200'];
    }
  };
};

var useStyles = makeStyles["default"](function (theme) {
  return {
    root: _objectSpread({}, theme.typography.button, {
      display: 'inline-block',
      padding: '3px 8px',
      borderWidth: 1,
      borderStyle: 'solid',
      borderRadius: 24,
      borderColor: getBorderColor(theme),
      color: getColor(theme),
      backgroundColor: getBackgroundColor(theme),
      fontSize: 13,
      lineHeight: 1
    })
  };
});

var InfoChip = function InfoChip(props) {
  var styles = useStyles(props);
  return React__default["default"].createElement("span", _objectSpread({
    className: classNames__default["default"](styles.root, props.className)
  }, props), props.label);
};

module.exports = InfoChip;
